import { Component } from '@angular/core';
import { LoadingService } from '@app/core/loading.service';

@Component({
  selector: 'app-loading-overlay',
  templateUrl: './loading-overlay.component.html',
  styleUrls: ['./loading-overlay.component.css']
})
export class LoadingOverlayComponent {
  visible$ = this.loadingService.visible$;
  constructor(private loadingService: LoadingService) {}
}



// WEBPACK FOOTER //
// ./src/app/shared/loading-overlay/loading-overlay.component.ts